export default __webpack_public_path__ + "static/media/bg-api-powered-ecosystem.214cdde9.jpg";